import React, { useState, useEffect } from 'react';
import { TextField, TextFieldProps, InputAdornment, Grid, InputLabel } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye,
  faEyeSlash,
  faSquare,
  faArrowAltUp,
  faHorizontalRule,
} from '@fortawesome/pro-solid-svg-icons';
import styles from './EnhancedTextField.module.scss';

type EnhancedTextFieldPropsPart = {
  outerLabel?: string;
  type?: string;
  requiredIcon?: any,
  error?: boolean,
};

export type EnhancedTextFieldProps = TextFieldProps & EnhancedTextFieldPropsPart;

const EnhancedTextField = ({
  outerLabel,
  type = 'text',
  InputProps,
  inputProps,
  requiredIcon,
  error,
  ...props
}: EnhancedTextFieldProps): JSX.Element => {
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [capsActivated, setCapsActivated] = useState(false);

  const capLockHandler = (event: Event) => {
    setCapsActivated((event as KeyboardEvent).getModifierState?.('CapsLock') || false);
  };
  useEffect(() => {
    ['keydown', 'keyup'].forEach(event => window.addEventListener(event, capLockHandler));
    return () => {
      ['keydown', 'keyup'].forEach(event => window.removeEventListener(event, capLockHandler));
    };
  }, [capsActivated]);

  const isPasswordType = type === 'password';

  return (
    <Grid item xs={12} className={styles.inputWrapper}>
      {outerLabel && (
      <InputLabel error={error}>
        {outerLabel}
        {requiredIcon && ' *'}
      </InputLabel>
      )}
      <TextField
        {...props}
        error={error}
        type={passwordVisibility && isPasswordType ? 'text' : type}
        // inputProps for input element, InputProps for Mui Input. I know, confusing...
        inputProps={{
          ...inputProps,
          'aria-label': outerLabel,
        }}
        classes={{ root: styles.input }}
        // eslint-disable-next-line react/jsx-no-duplicate-props
        InputProps={{
          ...InputProps,
          endAdornment: (
            <InputAdornment position='end'>
              {isPasswordType && capsActivated && (
                <div
                  data-testid='capslock-icon'
                  aria-label='caps lock is on'
                  role='img'
                  className={`${styles.capsIcon} fa-layers fa-fw`}
                >
                  <FontAwesomeIcon mask={faSquare} icon={faArrowAltUp} transform='shrink-5' />
                  <FontAwesomeIcon icon={faHorizontalRule} transform='shrink-7 down-3' />
                </div>
              )}
              {isPasswordType && (
                <button
                  type='button'
                  aria-label='toggle password visibility'
                  onClick={() => setPasswordVisibility(!passwordVisibility)}
                  className={styles.visiblityIcon}
                >
                  {passwordVisibility ? (
                    <FontAwesomeIcon data-testid='eye-icon' aria-hidden='true' icon={faEye} />
                  ) : (
                    <FontAwesomeIcon
                      data-testid='eye-slashed-icon'
                      aria-hidden='true'
                      icon={faEyeSlash}
                    />
                  )}
                </button>
              )}
            </InputAdornment>
          ),
        }}
      />
    </Grid>
  );
};

export default EnhancedTextField;
